import axios from './axios'
import generateService from './generator'

function service(endpoint) {
    const base = generateService(endpoint);

    function fetchGroups() {
        return axios.get('admin/component-groups').then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function storeGroup(data) {
        return axios.post('admin/component-groups', data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchVersions(componentId) {
        return axios.get(`${endpoint}/${componentId}/versions`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function storeVersion(componentId, data) {
        return axios.post(`${endpoint}/${componentId}/versions`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function publishVersion(versionId, data) {
        return axios.post(`admin/component-versions/${versionId}/publish`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function deprecateVersion(versionId) {
        return axios.post(`admin/component-versions/${versionId}/deprecate`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchCtas(componentId) {
        return axios.get(`${endpoint}/${componentId}/ctas`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function storeCta(versionId, data) {
        return axios.post(`admin/component-versions/${versionId}/ctas`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function destroyCta(ctaId) {
        return axios.delete(`admin/component-ctas/${ctaId}`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchList: base.fetchList,
        fetchAll: base.fetchAll,
        fetchItem: base.fetchItem,
        store: base.store,
        fetchGroups,
        storeGroup,
        fetchVersions,
        storeVersion,
        publishVersion,
        deprecateVersion,
        fetchCtas,
        storeCta,
        destroyCta
    }
}

export default service
